/**
 * Corporate Grind – Storefront Enhancements v14.1.0
 * 
 * CHANGES v14.1.0:
 * - CART NOTIFICATION: Quick Add now triggers native Shopify cart notification drawer
 * - HYBRID SWATCHES: Supports Liquid-rendered swatches (data-cg-liquid-swatches)
 * - FALLBACK: If no Liquid swatches, JS generates them (legacy mode)
 * - Quick Add success now shows View Cart + Checkout links
 * 
 * FILES:
 * - assets/corporate-grind.js (this file)
 * - snippets/card-product.liquid (render swatches)
 * - snippets/cg-color-swatches.liquid (NEW - swatch rendering)
 */

(function() {
  "use strict";

  // ========================================
  // CART NOTIFICATION INTEGRATION
  // ========================================
  
  /**
   * Open cart notification drawer after successful add
   * Uses Shopify's native cart-notification component
   */
  function openCartNotification(cartData) {
    var cartNotification = document.querySelector('cart-notification');
    if (cartNotification && typeof cartNotification.renderContents === 'function') {
      cartNotification.renderContents(cartData);
    } else {
      // Fallback: redirect to cart if notification not available
      console.log('[CG v14] Cart notification not available, showing inline');
    }
  }
  
  /**
   * Update cart count in header
   */
  function updateCartCount(count) {
    var countEls = document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count]');
    countEls.forEach(function(el) {
      if (!el.classList.contains('visually-hidden')) {
        el.textContent = count;
      }
    });
    // Show bubble if was hidden
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble && count > 0) {
      bubble.style.display = '';
    }
  }

  /**
   * Add to cart with notification support
   * @param {number} variantId - Shopify variant ID
   * @param {number} quantity - Quantity to add
   * @param {Object} callbacks - { onSuccess, onError, onStart }
   */
  function addToCartWithNotification(variantId, quantity, callbacks) {
    callbacks = callbacks || {};
    
    if (callbacks.onStart) callbacks.onStart();
    
    // Sections to render for cart notification
    var sections = 'cart-notification-product,cart-icon-bubble';
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity || 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    })
    .then(function(data) {
      // Update cart count
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        updateCartCount(cart.item_count);
      });
      
      // Open notification drawer if available
      if (data.sections) {
        openCartNotification(data);
      }
      
      if (callbacks.onSuccess) callbacks.onSuccess(data);
      
      // Analytics
      if (typeof window.cgAnalytics === 'function') {
        window.cgAnalytics('add_to_cart', { variant_id: variantId, quantity: quantity });
      }
    })
    .catch(function(error) {
      console.error('[CG v14] Add to cart error:', error);
      if (callbacks.onError) callbacks.onError(error);
    });
  }

  // ========================================
  // COLOR MAP (CSS colors for swatches)
  // ========================================
  
  var CG_COLOR_MAP = {
    "black": "#000000",
    "white": "#FFFFFF",
    "charcoal": "#36454F",
    "charcoal heather": "#4A4A4A",
    "dark heather": "#3A3A3A",
    "navy": "#001F3F",
    "dark grey heather": "#5C5C5C",
    "royal": "#4169E1",
    "sport grey": "#8B8B8B",
    "red": "#DC143C",
    "maroon": "#800000",
    "forest green": "#228B22",
    "heather": "#9E9E9E",
    "ash": "#B2BEB5",
    "light blue": "#ADD8E6",
    "natural": "#F5F0E1",
    "ice grey": "#C4C8CB",
    "sand": "#C2B280"
  };

  function getColorHex(colorName) {
    if (!colorName) return '#808080';
    var key = colorName.toLowerCase().trim();
    return CG_COLOR_MAP[key] || '#808080';
  }

  // ========================================
  // COLLECTION PAGE SWATCHES (HYBRID MODE)
  // ========================================
  
  /**
   * v14.1.0: Hybrid Liquid/JS swatch system
   * 
   * Mode 1: Liquid-rendered swatches (preferred)
   * - Swatches already in HTML with data-* attributes
   * - JS just attaches event handlers
   * 
   * Mode 2: JS-generated swatches (fallback)
   * - No Liquid swatches found
   * - Fetch product JSON and generate swatches
   */
  function initCollectionSwatches() {
    var cards = document.querySelectorAll('.card-wrapper[data-cg-handle]');
    if (!cards.length) return;
    
    cards.forEach(function(card) {
      // Check for Liquid-rendered swatches (preferred)
      var liquidSwatches = card.querySelector('[data-cg-liquid-swatches]');
      
      if (liquidSwatches) {
        // Mode 1: Liquid-rendered - just attach events
        initLiquidSwatchEvents(card, liquidSwatches);
      } else {
        // Mode 2: JS-generated (fallback for legacy)
        initJsSwatches(card);
      }
    });
  }

  /**
   * Mode 1: Attach events to Liquid-rendered swatches
   * Swatches already have data-color, data-image-url, data-variant-id
   */
  function initLiquidSwatchEvents(card, swatchContainer) {
    var dots = swatchContainer.querySelectorAll('[data-cg-color-dot]');
    var imgEl = card.querySelector('.card__media img.motion-reduce');
    var handle = card.getAttribute('data-cg-handle');
    var quickAddBtn = swatchContainer.querySelector('[data-cg-quick-add]');
    var sizeSelector = swatchContainer.querySelector('[data-cg-size-selector]');
    
    // Hover: swap image
    dots.forEach(function(dot) {
      dot.addEventListener('mouseenter', function() {
        var imgUrl = dot.getAttribute('data-image-url');
        if (imgEl && imgUrl) {
          imgEl.src = imgUrl;
          imgEl.srcset = imgUrl;
        }
        dots.forEach(function(d) { d.classList.remove('cg-color-active'); });
        dot.classList.add('cg-color-active');
      });
      
      // Click: navigate to product with variant
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = dot.getAttribute('data-variant-id');
        if (handle && variantId) {
          window.location.href = '/products/' + handle + '?variant=' + variantId;
        }
      });
    });
    
    // Quick Add button
    if (quickAddBtn && sizeSelector) {
      initQuickAddEvents(quickAddBtn, sizeSelector, swatchContainer);
    }
  }

  /**
   * Quick Add button events
   */
  function initQuickAddEvents(btn, sizeSelector, container) {
    var sizePills = sizeSelector.querySelectorAll('[data-cg-size-pill]');
    var msgEl = container.querySelector('[data-cg-qa-msg]');
    
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      var isOpen = sizeSelector.classList.contains('cg-size-open');
      sizeSelector.classList.toggle('cg-size-open');
      btn.textContent = isOpen ? 'Quick Add' : 'Select Size ▲';
    });
    
    // Size pill clicks
    sizePills.forEach(function(pill) {
      pill.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var variantId = pill.getAttribute('data-variant-id');
        var size = pill.getAttribute('data-size');
        
        if (!variantId) return;
        
        pill.classList.add('cg-adding');
        var originalText = pill.textContent;
        pill.textContent = '...';
        
        addToCartWithNotification(parseInt(variantId, 10), 1, {
          onSuccess: function() {
            pill.classList.remove('cg-adding');
            pill.textContent = originalText;
            sizeSelector.classList.remove('cg-size-open');
            btn.textContent = 'Quick Add';
            
            // Show success message with cart link
            if (msgEl) {
              msgEl.innerHTML = '✓ Added! <a href="/cart" style="text-decoration:underline;margin-left:4px;">View Cart</a>';
              msgEl.className = 'cg-qa-msg cg-qa-msg--success';
              msgEl.style.display = 'block';
              setTimeout(function() { msgEl.style.display = 'none'; }, 4000);
            }
          },
          onError: function() {
            pill.classList.remove('cg-adding');
            pill.textContent = originalText;
            if (msgEl) {
              msgEl.textContent = 'Error - try again';
              msgEl.className = 'cg-qa-msg cg-qa-msg--error';
              msgEl.style.display = 'block';
              setTimeout(function() { msgEl.style.display = 'none'; }, 3000);
            }
          }
        });
      });
    });
  }

  /**
   * Mode 2: JS-generated swatches (legacy fallback)
   * Only runs if no Liquid swatches found
   */
  function initJsSwatches(card) {
    var handle = card.getAttribute('data-cg-handle');
    if (!handle) return;
    
    // Check if already processed
    if (card.querySelector('.cg-swatch-row')) return;
    
    var priceEl = card.querySelector('.price');
    if (!priceEl) return;
    
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        renderJsSwatches(card, product, priceEl);
      })
      .catch(function(err) {
        console.warn('[CG v14] Failed to load product:', handle, err);
      });
  }

  /**
   * Render swatches via JS (legacy mode)
   */
  function renderJsSwatches(card, product, priceEl) {
    var imgEl = card.querySelector('.card__media img.motion-reduce');
    var colorOptionIdx = -1;
    var sizeOptionIdx = -1;
    
    // Find Color and Size option indices
    for (var i = 0; i < product.options.length; i++) {
      var optName = (product.options[i].name || product.options[i]).toString().toLowerCase();
      if (optName === 'color' || optName === 'colour') colorOptionIdx = i;
      if (optName === 'size') sizeOptionIdx = i;
    }
    
    // Build color map
    var colorVariantMap = {};
    product.variants.forEach(function(v) {
      if (colorOptionIdx >= 0) {
        var color = v.options[colorOptionIdx];
        if (!colorVariantMap[color]) {
          colorVariantMap[color] = {
            color: color,
            imageUrl: v.featured_image ? v.featured_image.src.replace(/\.jpg|\.png/, '_533x.jpg') : null,
            variant: v
          };
        }
      }
    });
    
    var colors = Object.keys(colorVariantMap);
    if (colors.length === 0) return;
    
    // Create wrapper
    var wrapper = document.createElement('div');
    wrapper.className = 'cg-swatch-row';
    wrapper.setAttribute('data-cg-js-swatches', 'true');
    
    // Color dots (max 5 visible)
    var dotsContainer = document.createElement('div');
    dotsContainer.className = 'cg-color-dots';
    
    var visibleColors = colors.slice(0, 5);
    var hiddenCount = colors.length - 5;
    
    visibleColors.forEach(function(color, idx) {
      var data = colorVariantMap[color];
      var dot = document.createElement('span');
      dot.className = 'cg-color-dot' + (idx === 0 ? ' cg-color-active' : '');
      dot.style.backgroundColor = getColorHex(color);
      dot.title = color;
      dot.setAttribute('data-color', color);
      
      dot.addEventListener('mouseenter', function() {
        if (data.imageUrl && imgEl) {
          imgEl.src = data.imageUrl;
          imgEl.srcset = data.imageUrl;
        }
        dotsContainer.querySelectorAll('.cg-color-dot').forEach(function(d) {
          d.classList.remove('cg-color-active');
        });
        dot.classList.add('cg-color-active');
      });
      
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = '/products/' + product.handle + '?variant=' + data.variant.id;
      });
      
      dotsContainer.appendChild(dot);
    });
    
    // Overflow badge
    if (hiddenCount > 0) {
      var badge = document.createElement('span');
      badge.className = 'cg-color-overflow';
      badge.textContent = '+' + hiddenCount;
      dotsContainer.appendChild(badge);
    }
    
    wrapper.appendChild(dotsContainer);
    
    // Quick Add button + Size selector
    if (sizeOptionIdx >= 0) {
      var sizeSelector = document.createElement('div');
      sizeSelector.className = 'cg-size-selector';
      sizeSelector.setAttribute('data-cg-size-selector', 'true');
      
      var qaMsg = document.createElement('div');
      qaMsg.className = 'cg-qa-msg';
      qaMsg.setAttribute('data-cg-qa-msg', 'true');
      qaMsg.style.display = 'none';
      
      // Get sizes from first color's variants
      var sizeVariants = [];
      product.variants.forEach(function(v) {
        if (colorOptionIdx >= 0 && v.options[colorOptionIdx] === colors[0]) {
          sizeVariants.push({
            size: v.options[sizeOptionIdx],
            variant: v
          });
        }
      });
      
      sizeVariants.forEach(function(sv) {
        var pill = document.createElement('button');
        pill.className = 'cg-size-pill' + (!sv.variant.available ? ' cg-size-oos' : '');
        pill.textContent = sv.size;
        pill.setAttribute('data-cg-size-pill', 'true');
        pill.setAttribute('data-variant-id', sv.variant.id);
        pill.setAttribute('data-size', sv.size);
        
        if (!sv.variant.available) {
          pill.disabled = true;
        } else {
          pill.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            pill.classList.add('cg-adding');
            pill.textContent = '...';
            
            addToCartWithNotification(sv.variant.id, 1, {
              onSuccess: function() {
                pill.classList.remove('cg-adding');
                pill.textContent = sv.size;
                sizeSelector.classList.remove('cg-size-open');
                qvBtn.textContent = 'Quick Add';
                qaMsg.innerHTML = '✓ Added! <a href="/cart" style="text-decoration:underline;margin-left:4px;">View Cart</a>';
                qaMsg.className = 'cg-qa-msg cg-qa-msg--success';
                qaMsg.style.display = 'block';
                setTimeout(function() { qaMsg.style.display = 'none'; }, 4000);
              },
              onError: function() {
                pill.classList.remove('cg-adding');
                pill.textContent = sv.size;
                qaMsg.textContent = 'Error - try again';
                qaMsg.className = 'cg-qa-msg cg-qa-msg--error';
                qaMsg.style.display = 'block';
                setTimeout(function() { qaMsg.style.display = 'none'; }, 3000);
              }
            });
          });
        }
        
        sizeSelector.appendChild(pill);
      });
      
      var qvBtn = document.createElement('button');
      qvBtn.className = 'cg-qv-btn';
      qvBtn.textContent = 'Quick Add';
      qvBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = sizeSelector.classList.toggle('cg-size-open');
        qvBtn.textContent = isOpen ? 'Select Size ▲' : 'Quick Add';
      });
      
      wrapper.appendChild(qvBtn);
      wrapper.appendChild(sizeSelector);
      wrapper.appendChild(qaMsg);
    }
    
    priceEl.parentNode.insertBefore(wrapper, priceEl.nextSibling);
  }

  // ========================================
  // PRODUCT PAGE: Sticky Add-to-Cart Integration
  // ========================================
  
  function initProductPageStickyATC() {
    // This is handled inline in main-product.liquid
    // Just ensure cart notification works here too
    var productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;
    
    // Intercept form submit for notification
    productForm.addEventListener('submit', function(e) {
      // Let native form handling work, but Shopify's product-form.js
      // should handle cart notification if configured
    });
  }

  // ========================================
  // CSS STYLES
  // ========================================
  
  function injectStyles() {
    if (document.getElementById('cg-styles-v14')) return;
    
    var style = document.createElement('style');
    style.id = 'cg-styles-v14';
    style.textContent = `
      /* CG Swatch Styles v14 */
      .cg-swatch-row {
        margin-top: 8px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 6px;
      }
      
      .cg-color-dots {
        display: flex;
        gap: 4px;
        align-items: center;
      }
      
      .cg-color-dot {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid #ddd;
        cursor: pointer;
        transition: transform 0.15s, box-shadow 0.15s;
      }
      
      .cg-color-dot:hover,
      .cg-color-dot.cg-color-active {
        transform: scale(1.2);
        box-shadow: 0 0 0 2px #000;
      }
      
      .cg-color-overflow {
        font-size: 10px;
        color: #666;
        padding: 2px 4px;
        background: #f0f0f0;
        border-radius: 8px;
      }
      
      .cg-qv-btn {
        font-size: 11px;
        padding: 4px 10px;
        background: #000;
        color: #fff;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        transition: background 0.2s;
      }
      
      .cg-qv-btn:hover {
        background: #333;
      }
      
      .cg-size-selector {
        display: none;
        flex-wrap: wrap;
        gap: 4px;
        margin-top: 6px;
        width: 100%;
      }
      
      .cg-size-selector.cg-size-open {
        display: flex;
      }
      
      .cg-size-pill {
        font-size: 10px;
        padding: 4px 8px;
        background: #f5f5f5;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.15s;
      }
      
      .cg-size-pill:hover:not(:disabled) {
        background: #000;
        color: #fff;
        border-color: #000;
      }
      
      .cg-size-pill.cg-adding {
        opacity: 0.6;
        pointer-events: none;
      }
      
      .cg-size-pill.cg-size-oos {
        opacity: 0.4;
        text-decoration: line-through;
        cursor: not-allowed;
      }
      
      .cg-qa-msg {
        font-size: 11px;
        padding: 4px 8px;
        border-radius: 4px;
        margin-top: 4px;
        width: 100%;
      }
      
      .cg-qa-msg--success {
        background: #d4edda;
        color: #155724;
      }
      
      .cg-qa-msg--error {
        background: #f8d7da;
        color: #721c24;
      }
      
      /* Liquid-rendered swatches use same classes */
      [data-cg-liquid-swatches] {
        margin-top: 8px;
      }
    `;
    
    document.head.appendChild(style);
  }

  // ========================================
  // INITIALIZATION
  // ========================================
  
  function init() {
    injectStyles();
    
    // Collection page swatches
    if (document.querySelector('.card-wrapper')) {
      initCollectionSwatches();
    }
    
    // Product page integrations
    if (document.querySelector('[data-product-form]')) {
      initProductPageStickyATC();
    }
    
    console.log('[CG v14.1.0] Initialized – Cart notification + Hybrid swatches');
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Export for external use
  window.CGStorefront = {
    addToCart: addToCartWithNotification,
    updateCartCount: updateCartCount,
    version: '14.0.0'
  };

})();
